/* eslint-disable camelcase */
import {
  createSelector,
} from 'reselect';

import {
  getResourceMap,
  getResourceMappedList,
} from './resources';

import {
  invoicesSelector,
} from './payments';

import {
  getIntervalABBR,
} from '../utils';

export const getIntents = createSelector(
  [
    getResourceMappedList('paymentIntents'),
    invoicesSelector,
    getResourceMap('products'),
  ],
  (
    intents,
    invoices,
    productsMap,
  ) => intents.map(
    intent => ({
      ...intent,
      product_data: productsMap[Number(intent.metadata?.product_id)],
      invoice_data: invoices.find(
        i => i.id === intent.invoice,
      ),
    }),
  ),
);

export const getPlansOption = createSelector(
  getResourceMappedList('productPlans'),
  (plans) => plans
    .filter(plan => plan.active)
    .map(plan => ({
      value: plan.id,
      label: `${plan.name},  $${plan.amount}/${getIntervalABBR(plan.interval)}`,
    })),
);
